/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AppSecopsDashboardInsights {
    __type: string;

    protected setDiscriminator(type: string) {
        this.__type = type;
    }

    getFixupPrototypeFunction() { return AppSecopsDashboardInsights.fixupPrototype; }

    static newInstance(model: Partial<AppSecopsDashboardInsights>): AppSecopsDashboardInsights {
        let obj = Object.assign(new AppSecopsDashboardInsights(), model);
        AppSecopsDashboardInsights.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AppSecopsDashboardInsights>): AppSecopsDashboardInsights {
        if (!model) return null;
        return AppSecopsDashboardInsights.newInstance(<AppSecopsDashboardInsights> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AppSecopsDashboardInsights) {
        if (!obj) return;

        models.AppSecopsDashboardInsights.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AppSecopsDashboardInsights): boolean {
        switch (obj.__type)
        {
            case "AppSecopsInsightsTopActionableVulnerability":
                Object.setPrototypeOf(obj, models.AppSecopsInsightsTopActionableVulnerability.prototype);
                break;
        }
        return true; // Tell the caller this is a polymorphic type, it should not overwrite the prototype.
    }

    static getTypeHierarchy(): (typeof AppSecopsDashboardInsights)[] {
        return [
            models.AppSecopsInsightsTopActionableVulnerability,
        ];
    }

    fixupFields() {
    }

}
